import styled, { css } from 'styled-components';
import {
  desktop_breakpoint_extended,
  desktop_container_maxwidth,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

const sharedStyles = css`
  .slide-selected ~ .slide-selected {
    user-select: none;
  }

  .family-name {
    font-weight: 600;
  }

  .bullet {
    color: ${Colors.primary.claytonBlue.standard};
    padding: 0 0.44rem;
  }

  .location {
    font-style: italic;
  }

  .testimonials {
    .focus-grabber {
      height: 100%;
    }

    .slider-wrapper .slide {
      background: none;
    }

    .control-dots {
      display: none;
    }

    .slideshow,
    .slideshow > div,
    .slideshow > div > div,
    .carousel-root,
    .carousel,
    .slider-wrapper,
    .slider,
    .slider {
      height: 100%;
    }

    .carousel.carousel-slider button.control-arrow {
      display: none;
    }
  }

  .testimonial {
    display: flex;
    flex-direction: column;
    margin: auto;
    width: 86%;

    .testimonial-quote-container {
      box-shadow: rgb(0 0 0 / 20%) 0px 3px 7px 0px;
      align-items: center;
      background-color: ${Colors.primary.white.standard};
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: center;

      .testimonial-quote {
        align-items: center;
        display: flex;
        flex-direction: column;
        padding: 20px;

        .standard.intro {
          color: ${Colors.accent.bedtime.standard};
        }

        .testimonial-divider {
          border-bottom: 1px solid ${Colors.primary.black.tint};
          display: block;
          margin: 20px 0;
          width: 50px;
        }
        .testimonial-author {
          white-space: nowrap;
        }

        svg {
          margin-bottom: 15px;
        }

        a.xsmall,
        a.xsmall:visited,
        a.xsmall:hover,
        a.xsmall:active {
          color: ${Colors.primary.claytonBlue.standard};
          cursor: pointer;
          font-weight: 600;
          letter-spacing: 1px;
          margin-top: 10px;
          text-decoration: none;
          text-transform: uppercase;
        }
      }
    }
  }

  .testimonial-controls {
    align-items: center;
    background-color: ${Colors.primary.claytonBlue.standard};
    color: ${Colors.primary.white.standard};
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: auto;
    position: relative;
    top: -33px;
    width: 150px;

    button {
      * {
        pointer-events: none;
      }

      svg {
        margin-top: 5px;

        * {
          fill: ${Colors.primary.white.standard};
        }
      }
    }

    .testimonial-indicator {
      color: ${Colors.primary.white.standard};
    }
  }
`;

export const TestimonialsStyles = styled.div`
  background-color: ${(props) => props.$backgroundColor};
  height: 700px;
  margin-bottom: 250px;
  position: relative;

  ${sharedStyles};

  .left-bg,
  .right-bg {
    display: none;
  }

  .testimonials-container {
    height: 100%;
    margin: auto;
    max-width: 500px;
    position: relative;
  }

  h2 {
    color: ${Colors.primary.white.standard};
    margin: 0 auto;
    padding: 50px 0 0;
    position: relative;
    text-align: center;
    width: 86%;
  }

  .sub-header {
    color: ${Colors.primary.white.standard};
    font-size: 18px;
    margin: 8px 0 50px;
    text-align: center;
  }

  .testimonials {
    height: 650px;
  }

  .testimonial {
    height: calc(100% - 10px);
  }

  .slider-wrapper .slide img {
    height: auto;
  }

  @media screen and (min-width: 375px) {
    .testimonial-quote-container {
      margin: 0 auto;
      width: 92%;
    }
  }

  @media screen and (min-width: 768px) {
    .testimonial-quote-container {
      width: auto;
    }
  }

  @media screen and (min-width: ${desktop_breakpoint_extended}px) {
    height: 500px;
    background-image: url(${(props) => props.$backgroundImage});
    background-size: cover;

    .left-bg,
    .right-bg {
      display: block;
      max-height: 100%;
      position: absolute;
    }

    .left-bg {
      left: 0;
      top: 0;
    }

    .right-bg {
      right: 0;
      top: 0;
    }

    .testimonials-container {
      max-width: none;
      width: 900px;
    }

    .testimonials {
      height: calc(100% - 50px);
    }

    .testimonial {
      align-items: center;
      flex-direction: row;
      position: relative;
      width: 100%;

      .testimonial-quote-container {
        height: 350px;
        position: absolute;
        right: 0;
        width: 350px;
      }
    }

    .slider-wrapper .slide div img {
      max-height: none;
      width: calc(100% - 300px);
    }

    .testimonial-controls {
      position: absolute;
      right: 100px;
      top: calc(100% + 9px);
    }
  }

  @media screen and (min-width: ${desktop_container_maxwidth}px) {
    margin-bottom: 325px;

    .testimonials-container {
      width: 1224px;
    }

    .testimonials {
      height: 630px;
    }

    .testimonial {
      .testimonial-quote-container {
        height: 417px;
        width: 496px;

        .testimonial-quote {
          padding: 72px;
        }
      }
    }

    .testimonial-controls {
      right: 175px;
      top: calc(100% + 132px);
    }
  }
`;

export const TestimonialsFullWidthStyles = styled.div`
  position: relative;

  .testimonials-container {
    height: 100%;
    margin: auto;
    max-width: 650px;
    position: relative;
  }

  ${sharedStyles};

  .testimonials {
    min-height: 534px;
  }

  .testimonial-controls {
    top: -30px;
  }

  @media screen and (min-width: ${desktop_breakpoint_extended}px) {
    .testimonials-container {
      max-width: none;
      width: 100%;
    }

    .testimonials {
      min-height: 460px;
    }

    .testimonial {
      align-items: center;
      flex-direction: row;
      position: relative;
      width: 100%;

      .testimonial-quote-container {
        height: 320px;
        left: 45px;
        position: absolute;
        top: calc(50% - 160px);
        width: 350px;
      }
    }

    .slider-wrapper .slide div img {
      max-height: none;
      width: 100%;
    }

    .testimonial-controls {
      position: absolute;
      left: 145px;
      top: 400px;
    }
  }

  @media screen and (min-width: 1366px) {
    .testimonials {
      min-height: 590px;
    }

    .testimonial {
      min-height: 590px;

      .testimonial-quote-container {
        height: 417px;
        left: 75px;
        top: 90px;
        width: 496px;

        .testimonial-quote {
          padding: 72px;
        }
      }
    }

    .testimonial-controls {
      left: 248px;
      top: 484px;
    }
  }

  @media screen and (min-width: 1920px) {
    .testimonial {
      .testimonial-quote-container {
        top: 208px;
      }
    }

    .testimonial-controls {
      top: 602px;
    }
  }
`;
